import defaultTheme from './defaultTheme';
const cathayTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#006564', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#006564', background: '#006564' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#006564' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#006564', border: '#006564', background: '#006564' }), field: {
        focus: '#006564',
        label: '#006564',
        icon: '#006564',
    } });
export default cathayTheme;
